import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import ProductDetail from "./pages/ProductDetail";
import SeoLandingPage, { SEO_LANDING_PAGES } from "./pages/SeoLandingPage";
import AdminApp from "./admin/AdminApp";
import PaymentPage from "./pages/PaymentPage";
import MetaPixelRouteTracker from "./components/MetaPixelRouteTracker";
import RouteScrollManager from "./components/RouteScrollManager";
import SiteLayout from "./components/SiteLayout";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <MetaPixelRouteTracker />
    <RouteScrollManager />
    <Routes>
      <Route
        path="/"
        element={
          <SiteLayout>
            <App />
          </SiteLayout>
        }
      />
      {Object.values(SEO_LANDING_PAGES).map((page) => (
        <Route
          key={page.path}
          path={page.path}
          element={
            <SiteLayout>
              <SeoLandingPage pageKey={page.key} />
            </SiteLayout>
          }
        />
      ))}
      <Route
        path="/:slug"
        element={
          <SiteLayout>
            <ProductDetail />
          </SiteLayout>
        }
      />
      <Route path="/admin" element={<AdminApp />} />
      <Route path="/payment/:id" element={<PaymentPage />} />
    </Routes>
  </BrowserRouter>
);

(() => {
  const preventImageActions = (event) => {
    const img = event.target instanceof HTMLElement && event.target.closest("img");
    if (img) event.preventDefault();
  };

  window.addEventListener("contextmenu", preventImageActions);
  window.addEventListener("dragstart", preventImageActions);
})();

// reportWebVitals();
